import graphql__bebee5d8ceb18e94dfcf from "./__generated__/EventCalendarDropdownButton_participativeModule.graphql.js";import { useCallback, useState } from "react";
import { graphql, useFragment } from "react-relay";
import { defineMessages } from "react-intl";
import compact from "lodash/compact";
import classNames from "classnames";

import parseDate from "../Utils/parseDate";
import { useFormatMessage } from "../Intl/Context";
import { useRoutesContext } from "../Routes/RoutesContext";
import Icon from "../Utils/Icon";
import Button from "../Buttons/Button";
import ButtonLink from "../Buttons/ButtonLink";

const EventCalendarDropdownButton = props => {
  const participativeModule = useFragment(
    EventCalendarDropdownButton_participativeModule,
    props.participativeModule
  );
  const {
    visualization: event,
    slug: participativeModuleSlug,
    title
  } = participativeModule;
  const { fullAddress } = event;
  const { allowAddingEventsToCalendar } = event.authorizations;

  const [isOpen, setIsOpen] = useState(false);

  const caretIconClassName = classNames("fa", {
    "fa-caret-down": !isOpen,
    "fa-caret-up": isOpen
  });

  const t = useFormatMessage();

  const labels = {
    addToCalendar: t(intlMessages.addToCalendar),
    addToOutlook: t(intlMessages.addToOutlook),
    addToGoogleCalendar: t(intlMessages.addToGoogleCalendar),
    addToOtherCalendar: t(intlMessages.addToOtherCalendar)
  };

  const { pathFor } = useRoutesContext();

  const eventPath = pathFor("participativeModule", { participativeModuleSlug });

  const eventCalendarAddPathFor = useCallback(
    format => [eventPath, format].join("."),
    [eventPath]
  );

  const formatGoogleCalendarDate = date =>
    date
      .toISOString()
      .replace(/(-|:)/g, "")
      .replace(/\.\d{3}Z/, "Z");

  const { protocol, host } = window.location;
  const eventUrl = `${protocol}//${host}${eventPath}`;
  const details = compact([eventUrl]).join("\n");
  const startsAt = parseDate(event.startsAt);
  const endsAt = event.endsAt && parseDate(event.endsAt);

  const dates = compact([
    formatGoogleCalendarDate(startsAt),
    endsAt && formatGoogleCalendarDate(endsAt)
  ]).join("/");

  // Force re-rendering dropdown placeholder

  if (!allowAddingEventsToCalendar) return null;

  const googleCalendarPath = [
    "http://www.google.com/calendar/event?action=TEMPLATE",
    `text=${title}`,
    `dates=${dates}`,
    `details=${details}`,
    `location=${fullAddress.replace(/(\r\n|\r|\n)/g, ", ")}`,
    "trp=false"
  ].join("&");

  const outlookCalendarPath = eventCalendarAddPathFor("vcs");
  const otherCalendarPath = eventCalendarAddPathFor("ics");

  return (
    <div className="event-calendar-dropdown-button btn-group dropdown show margin-top-sm">
      <h2 className="text-default">
        <Button
          onClick={() => setIsOpen(!isOpen)}
          type="button"
          className="btn-unstyled"
          aria-expanded={isOpen}
        >
          <span className="with-icon">
            <Icon className="icon-plus" />
            <span className="with-icon-text">{labels.addToCalendar}</span>
            <Icon className={caretIconClassName} />
          </span>
        </Button>
      </h2>

      {isOpen && (
        <ul className="dropdown-menu show">
          <li>
            <ButtonLink
              LinkComponent="a"
              href={outlookCalendarPath}
              className="btn-unstyled dropdown-item padding-x-md"
              label={labels.addToOutlook}
              target="_self"
            />
          </li>
          <li>
            <ButtonLink
              LinkComponent="a"
              href={googleCalendarPath}
              className="btn-unstyled dropdown-item padding-x-md"
              label={labels.addToGoogleCalendar}
              target="_blank"
            />
          </li>
          <li>
            <ButtonLink
              LinkComponent="a"
              href={otherCalendarPath}
              className="btn-unstyled dropdown-item padding-x-md"
              label={labels.addToOtherCalendar}
              target="_self"
            />
          </li>
        </ul>
      )}
    </div>
  );
};

const EventCalendarDropdownButton_participativeModule = graphql__bebee5d8ceb18e94dfcf;

export default EventCalendarDropdownButton;

const intlMessages = defineMessages({
  addToCalendar: {
    id: "event.show.addToCalendar",
    defaultMessage: "Ajouter à mon agenda"
  },
  addToOutlook: {
    id: "event.show.addToOutlook",
    defaultMessage: "Outlook"
  },
  addToGoogleCalendar: {
    id: "event.show.addToGoogleCalendar",
    defaultMessage: "Google Agenda"
  },
  addToOtherCalendar: {
    id: "event.show.addToOtherCalendar",
    defaultMessage: "Autres"
  }
});
